import axios from "axios";
import { authHeader } from './utils'
import {API_URL} from '../config'


export const getBillingByUserService = async () => {
  try {
    let options = {
      headers: {
        "content-type": "application/json",
        ...authHeader()
      },
    };
    const response = await axios.get(
      `${API_URL}/billing/allByUser`,
      options
    );
    return response;
  } catch (e) {
    return e;
  }
};
